module.exports = __webpack_public_path__ + "static/media/amazon-fr-icon.43878a33.svg";